import React from 'react';

const Context = React.createContext<any>(undefined);

export default Context;
